import {Directive, Input} from '@angular/core';

interface TableRowActionTemplateContext<TItem extends object> {
  $implicit: TItem;
}

/**
 * Directive to perform content projection and data casting, to enable autocompletion and type inference in TS.
 *
 * To use it, just assign the directive in ng-template element, if you want to complete the fields, use the attr
 * [castDataTo]="myCustomType or myCustomInterface"
 *
 * The data can be obtained by doing (let-data, let-row, let-item) or any name, the value is implicit therefore there is no need to define
 * where to get it from (let-data="data")
 *
 * @example html
 *  <ng-template genTableRowAction [castDataTo]="myCustomType or myCustomInterface" let-item>
 *
 * @author Carlos Duardo <carlos.duardo@qualud.com>
 */
@Directive({
  selector: '[genTableRowAction]',
  standalone: true,
})
export class GenericTableRowActionTemplateDirective<TItem extends object = any> {
  @Input('genTableRowAction') $implicit!: TItem[] | string;

  static ngTemplateContextGuard<TItem extends object = any >(
    dir: GenericTableRowActionTemplateDirective<TItem>,
    ctx: unknown
  ): ctx is TableRowActionTemplateContext<TItem> {
    return true;
  }
}
